export const environment = {
  production: true,
  // path: '',
  stripeKey:
    'pk_live_51SOzCa9U122eiBFpLi3SwZvuxhyAkt1d8vreCcVEGow1aak0jxd6o5PLdXBd7LMnHbFmQgGT5U3oBvcwAyFAwAtQ00nyBy3bwi',
  urlStripe: 'https://zalona.fr/',
};
